// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import TopBar from "./components/TopBar";
// import HomePage from "./pages/HomePage";
// import NewApplicationPage from "./pages/NewApplicationPage";
// import ApplicationEdit from "./components/ApplicationEdit";
// import ApplicationForm from "./components/ApplicationForm";
// import ApplicationList from "./components/ApplicationList";

// function App() {
//   return (
//     <BrowserRouter>
//       <TopBar />

//       <Routes>
//         <Route path="/" element={<HomePage />} />
//         <Route path="/applications" element={<ApplicationList />} />
//         <Route path="/new-application" element={<NewApplicationPage />} />
//         <Route path="/edit-application/:id" element={<ApplicationEdit />} />
//         <Route path="/form" element={<ApplicationForm />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import TopBar from "./components/TopBar";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import HomePage from "./pages/HomePage";
import NewApplicationPage from "./pages/NewApplicationPage";

import ApplicationEdit from "./components/ApplicationEdit";
import ApplicationForm from "./components/ApplicationForm";
import ApplicationList from "./components/ApplicationList";


function App() {
  return (
    <Router>

      <Routes>

        {/* LOGIN PAGE */}
        <Route path="/login" element={<Login />} />

        {/* PROTECTED ROUTES */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <>
                <TopBar />
                <HomePage />
              </>
            </ProtectedRoute>
          }
        />

        <Route
          path="/applications"
          element={
            <ProtectedRoute>
              <>
                <TopBar />
                <ApplicationList />
              </>
            </ProtectedRoute>
          }
        />

        <Route
          path="/new-application"
          element={
            <ProtectedRoute>
              <>
                <TopBar />
                <NewApplicationPage />
              </>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-application/:id"
          element={
            <ProtectedRoute>
              <>
                <TopBar />
                <ApplicationEdit />
              </>
            </ProtectedRoute>
          }
        />

        <Route
          path="/form"
          element={
            <ProtectedRoute>
              <>
                <TopBar />
                <ApplicationForm />
              </>
            </ProtectedRoute>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;
